import { createBrowserRouter, Navigate } from "react-router-dom";

// Public pages
import Home              from "@/pages/public/Home";
import About             from "@/pages/public/About";
import Contact           from "@/pages/public/Contact";
import Pricing           from "@/pages/public/Pricing";
import FreeTrialPicker   from "@/pages/public/FreeTrialPicker";
import FreeTrialReportEditor from "@/pages/public/FreeTrialReportEditor";

// Private pages
import Dashboard         from "@/pages/private/Dashboard";
import Classes           from "@/pages/private/Classes";
import { OwnedClass }    from "@/pages/private/OwnedClass";
import { ReportCard }    from "@/pages/private/ReportCard";
import { ReportDefaults } from "@/pages/private/ReportDefaults";
import SharedClasses     from "@/pages/private/SharedClasses";
import SharedClass       from "@/pages/private/SharedClass";
import Usage             from "@/pages/private/Usage";
import Billing           from "@/pages/private/Billing";
import School            from "@/pages/private/School";

// Admin pages
import TeacherActivity      from "@/pages/private/admin/TeacherActivity";
import ManageClassOwnership from "@/pages/private/admin/ManageClassOwnership";
import ManageClassSharing   from "@/pages/private/admin/ManageClassSharing";
import AdminSettings        from "@/pages/private/admin/Settings";
import SeatManagement       from "@/pages/private/admin/SeatManagement";
import ClassShares          from "@/pages/private/admin/ClassShares";

// Layouts
import RootLayout      from "@/layouts/root-layout";
import DashboardLayout from "@/layouts/dashboard-layout";
import PublicLayout    from "@/layouts/public-layout";
import NotFound        from "@/pages/NotFound";

export const router = createBrowserRouter([
  {
    path: "/",
    element: <RootLayout />,
    children: [
      {
        element: <PublicLayout />,
        children: [
          { path: "/",             element: <Home /> },
          { path: "/about",        element: <About /> },
          { path: "/contact",      element: <Contact /> },
          { path: "/pricing",      element: <Pricing /> },
          { path: "/free-trial",   element: <FreeTrialPicker /> },
          { path: "/free-trial/:reportType", element: <FreeTrialReportEditor /> },
          // Legacy free-trial routes → redirect to new unified path
          { path: "/pgrc",         element: <Navigate to="/free-trial/pgrc1to6_2023_07" replace /> },
          { path: "/pgrc78",       element: <Navigate to="/free-trial/pgrc7to8_2023_07" replace /> },
          { path: "/pvrc",         element: <Navigate to="/free-trial/pvrc1to6_2023_09" replace /> },
          { path: "/pvrc78",       element: <Navigate to="/free-trial/pvrc7to8_2023_09" replace /> },
          { path: "/pvrc9to12sem", element: <Navigate to="/free-trial/pvrc9to12_2022_02_sem" replace /> },
        ],
      },
      {
        element: <DashboardLayout />,
        children: [
          { path: "/dashboard",                                           element: <Dashboard /> },
          { path: "/classes",                                             element: <Classes /> },
          { path: "/shared-classes",                                      element: <SharedClasses /> },
          { path: "/shared-classes/:sharedClassId",                       element: <SharedClass /> },
          { path: "/shared-classes/:sharedClassId/reports/:id",           element: <ReportCard /> },
          { path: "/classes/:reportGroupId",                              element: <OwnedClass /> },
          { path: "/classes/:reportGroupId/defaults",                     element: <ReportDefaults /> },
          { path: "/classes/:reportGroupId/reports/:id",                  element: <ReportCard /> },
          { path: "/usage",                                               element: <Usage /> },
          { path: "/billing",                                             element: <Billing /> },
          // School routes
          { path: "/schools",                  element: <School /> },
          { path: "/schools/teacher-activity",   element: <TeacherActivity /> },
          { path: "/schools/settings",         element: <AdminSettings /> },
          { path: "/schools/classes",          element: <ManageClassOwnership /> },
          { path: "/schools/classes/:classId", element: <ManageClassOwnership /> },
          { path: "/schools/share-requests",   element: <ManageClassSharing /> },
          { path: "/schools/seats",            element: <SeatManagement /> },
          { path: "/schools/class-shares",     element: <ClassShares /> },
        ],
      },
      { path: "*", element: <NotFound /> },
    ],
  },
]);
